import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f6cb5ad4 = () => interopDefault(import('../pages/affiliate/index.vue' /* webpackChunkName: "pages/affiliate/index" */))
const _4a113b6b = () => interopDefault(import('../pages/aktivasikartugaransi/index.vue' /* webpackChunkName: "pages/aktivasikartugaransi/index" */))
const _07b969e6 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _ac705124 = () => interopDefault(import('../pages/check-health/index.vue' /* webpackChunkName: "pages/check-health/index" */))
const _168b6cb3 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _aaf91476 = () => interopDefault(import('../pages/clearance-sale/index.vue' /* webpackChunkName: "pages/clearance-sale/index" */))
const _e32c2e00 = () => interopDefault(import('../pages/flashsale/index.vue' /* webpackChunkName: "pages/flashsale/index" */))
const _37296ece = () => interopDefault(import('../pages/forgot-password/index.vue' /* webpackChunkName: "pages/forgot-password/index" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _4e16ad99 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _49788fd1 = () => interopDefault(import('../pages/partner/index.vue' /* webpackChunkName: "pages/partner/index" */))
const _5fba350d = () => interopDefault(import('../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _326f8b74 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _37aa369b = () => interopDefault(import('../pages/account/address/index.vue' /* webpackChunkName: "pages/account/address/index" */))
const _78c411b4 = () => interopDefault(import('../pages/account/affiliate/index.vue' /* webpackChunkName: "pages/account/affiliate/index" */))
const _17bf4f88 = () => interopDefault(import('../pages/account/change-password.vue' /* webpackChunkName: "pages/account/change-password" */))
const _bb396bd2 = () => interopDefault(import('../pages/account/delete-account.vue' /* webpackChunkName: "pages/account/delete-account" */))
const _042aafa4 = () => interopDefault(import('../pages/account/home/index.vue' /* webpackChunkName: "pages/account/home/index" */))
const _a4a0a7c6 = () => interopDefault(import('../pages/account/lastseen.vue' /* webpackChunkName: "pages/account/lastseen" */))
const _51d10086 = () => interopDefault(import('../pages/account/not-reviewed.vue' /* webpackChunkName: "pages/account/not-reviewed" */))
const _34acf7f7 = () => interopDefault(import('../pages/account/notification.vue' /* webpackChunkName: "pages/account/notification" */))
const _9e0043a6 = () => interopDefault(import('../pages/account/payment/index.vue' /* webpackChunkName: "pages/account/payment/index" */))
const _277820b4 = () => interopDefault(import('../pages/account/point.vue' /* webpackChunkName: "pages/account/point" */))
const _256173e0 = () => interopDefault(import('../pages/account/profile/index.vue' /* webpackChunkName: "pages/account/profile/index" */))
const _621c18de = () => interopDefault(import('../pages/account/vouchers.vue' /* webpackChunkName: "pages/account/vouchers" */))
const _6a297c5e = () => interopDefault(import('../pages/account/wishlist.vue' /* webpackChunkName: "pages/account/wishlist" */))
const _7d07972b = () => interopDefault(import('../pages/affiliate/create-affiliate/index.vue' /* webpackChunkName: "pages/affiliate/create-affiliate/index" */))
const _52169c8e = () => interopDefault(import('../pages/affiliate/home/index.vue' /* webpackChunkName: "pages/affiliate/home/index" */))
const _f8a2a3e2 = () => interopDefault(import('../pages/affiliate/partner/index.vue' /* webpackChunkName: "pages/affiliate/partner/index" */))
const _24904260 = () => interopDefault(import('../pages/products/all.vue' /* webpackChunkName: "pages/products/all" */))
const _098141ac = () => interopDefault(import('../pages/account/address/add.vue' /* webpackChunkName: "pages/account/address/add" */))
const _a6cd76a6 = () => interopDefault(import('../pages/account/affiliate/bank-account/index.vue' /* webpackChunkName: "pages/account/affiliate/bank-account/index" */))
const _4546f8bc = () => interopDefault(import('../pages/account/affiliate/commission/index.vue' /* webpackChunkName: "pages/account/affiliate/commission/index" */))
const _698827cd = () => interopDefault(import('../pages/account/affiliate/product-list/index.vue' /* webpackChunkName: "pages/account/affiliate/product-list/index" */))
const _5ac47988 = () => interopDefault(import('../pages/account/payment/add.vue' /* webpackChunkName: "pages/account/payment/add" */))
const _691604bf = () => interopDefault(import('../pages/account/profile/edit/index.vue' /* webpackChunkName: "pages/account/profile/edit/index" */))
const _5179ae0d = () => interopDefault(import('../pages/account/shop/my-order/index.vue' /* webpackChunkName: "pages/account/shop/my-order/index" */))
const _47d40452 = () => interopDefault(import('../pages/account/shop/order-review/index.vue' /* webpackChunkName: "pages/account/shop/order-review/index" */))
const _37c65a63 = () => interopDefault(import('../pages/account/shop/warranty-history/index.vue' /* webpackChunkName: "pages/account/shop/warranty-history/index" */))
const _204e3de5 = () => interopDefault(import('../pages/account/shop/wishlist/index.vue' /* webpackChunkName: "pages/account/shop/wishlist/index" */))
const _8b426c88 = () => interopDefault(import('../pages/account/affiliate/bank-account/add.vue' /* webpackChunkName: "pages/account/affiliate/bank-account/add" */))
const _62fa27fe = () => interopDefault(import('../pages/account/affiliate/commission/withdrawal/index.vue' /* webpackChunkName: "pages/account/affiliate/commission/withdrawal/index" */))
const _561d5ffe = () => interopDefault(import('../pages/account/affiliate/product-list/add-product/index.vue' /* webpackChunkName: "pages/account/affiliate/product-list/add-product/index" */))
const _1fdd6de1 = () => interopDefault(import('../pages/account/shop/my-order/offline/index.vue' /* webpackChunkName: "pages/account/shop/my-order/offline/index" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3c13d911 = () => interopDefault(import('../pages/account/shop/my-order/offline/detail/_order_id/index.vue' /* webpackChunkName: "pages/account/shop/my-order/offline/detail/_order_id/index" */))
const _6243b12c = () => interopDefault(import('../pages/account/shop/my-order/review/add/_id.vue' /* webpackChunkName: "pages/account/shop/my-order/review/add/_id" */))
const _4201402c = () => interopDefault(import('../pages/account/shop/my-order/offline/detail/_order_id/invoice.vue' /* webpackChunkName: "pages/account/shop/my-order/offline/detail/_order_id/invoice" */))
const _37927665 = () => interopDefault(import('../pages/account/shop/my-order/detail/_order_id/index.vue' /* webpackChunkName: "pages/account/shop/my-order/detail/_order_id/index" */))
const _584dd880 = () => interopDefault(import('../pages/account/shop/my-order/detail/_order_id/invoice.vue' /* webpackChunkName: "pages/account/shop/my-order/detail/_order_id/invoice" */))
const _20286f42 = () => interopDefault(import('../pages/account/shop/my-order/detail/_order_id/invoice-backup.vue' /* webpackChunkName: "pages/account/shop/my-order/detail/_order_id/invoice-backup" */))
const _8f6b2b08 = () => interopDefault(import('../pages/account/address/edit/_id.vue' /* webpackChunkName: "pages/account/address/edit/_id" */))
const _754bf0f8 = () => interopDefault(import('../pages/affiliate/products/_section/index.vue' /* webpackChunkName: "pages/affiliate/products/_section/index" */))
const _252ce834 = () => interopDefault(import('../pages/password/reset/_token.vue' /* webpackChunkName: "pages/password/reset/_token" */))
const _4a143902 = () => interopDefault(import('../pages/review/add/_id.vue' /* webpackChunkName: "pages/review/add/_id" */))
const _32be645a = () => interopDefault(import('../pages/c1/_slug.vue' /* webpackChunkName: "pages/c1/_slug" */))
const _7b858094 = () => interopDefault(import('../pages/c2/_slug.vue' /* webpackChunkName: "pages/c2/_slug" */))
const _106a3355 = () => interopDefault(import('../pages/c3/_slug.vue' /* webpackChunkName: "pages/c3/_slug" */))
const _20d251a6 = () => interopDefault(import('../pages/linktree/_id.vue' /* webpackChunkName: "pages/linktree/_id" */))
const _12fa402f = () => interopDefault(import('../pages/page/_section/index.vue' /* webpackChunkName: "pages/page/_section/index" */))
const _66da5279 = () => interopDefault(import('../pages/partner/_id.vue' /* webpackChunkName: "pages/partner/_id" */))
const _4e33547c = () => interopDefault(import('../pages/payment-confirmation/_order_id.vue' /* webpackChunkName: "pages/payment-confirmation/_order_id" */))
const _122e2f9e = () => interopDefault(import('../pages/payment-detail/_order_id.vue' /* webpackChunkName: "pages/payment-detail/_order_id" */))
const _27eb6c73 = () => interopDefault(import('../pages/product/_slug/index.vue' /* webpackChunkName: "pages/product/_slug/index" */))
const _2a40083a = () => interopDefault(import('../pages/products/_section/index.vue' /* webpackChunkName: "pages/products/_section/index" */))
const _f2246742 = () => interopDefault(import('../pages/sale/_id/index.vue' /* webpackChunkName: "pages/sale/_id/index" */))
const _465cdf0c = () => interopDefault(import('../pages/users/_slug/index.vue' /* webpackChunkName: "pages/users/_slug/index" */))
const _7787220e = () => interopDefault(import('../pages/sale/_id/brand/_brandId.vue' /* webpackChunkName: "pages/sale/_id/brand/_brandId" */))
const _661ec510 = () => interopDefault(import('../pages/sale/_id/section/_idSection.vue' /* webpackChunkName: "pages/sale/_id/section/_idSection" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/affiliate",
    component: _f6cb5ad4,
    name: "affiliate"
  }, {
    path: "/aktivasikartugaransi",
    component: _4a113b6b,
    name: "aktivasikartugaransi"
  }, {
    path: "/cart",
    component: _07b969e6,
    name: "cart"
  }, {
    path: "/check-health",
    component: _ac705124,
    name: "check-health"
  }, {
    path: "/checkout",
    component: _168b6cb3,
    name: "checkout"
  }, {
    path: "/clearance-sale",
    component: _aaf91476,
    name: "clearance-sale"
  }, {
    path: "/flashsale",
    component: _e32c2e00,
    name: "flashsale"
  }, {
    path: "/forgot-password",
    component: _37296ece,
    name: "forgot-password"
  }, {
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/maintenance",
    component: _4e16ad99,
    name: "maintenance"
  }, {
    path: "/partner",
    component: _49788fd1,
    name: "partner"
  }, {
    path: "/register",
    component: _5fba350d,
    name: "register"
  }, {
    path: "/sale",
    component: _326f8b74,
    name: "sale"
  }, {
    path: "/account/address",
    component: _37aa369b,
    name: "account-address"
  }, {
    path: "/account/affiliate",
    component: _78c411b4,
    name: "account-affiliate"
  }, {
    path: "/account/change-password",
    component: _17bf4f88,
    name: "account-change-password"
  }, {
    path: "/account/delete-account",
    component: _bb396bd2,
    name: "account-delete-account"
  }, {
    path: "/account/home",
    component: _042aafa4,
    name: "account-home"
  }, {
    path: "/account/lastseen",
    component: _a4a0a7c6,
    name: "account-lastseen"
  }, {
    path: "/account/not-reviewed",
    component: _51d10086,
    name: "account-not-reviewed"
  }, {
    path: "/account/notification",
    component: _34acf7f7,
    name: "account-notification"
  }, {
    path: "/account/payment",
    component: _9e0043a6,
    name: "account-payment"
  }, {
    path: "/account/point",
    component: _277820b4,
    name: "account-point"
  }, {
    path: "/account/profile",
    component: _256173e0,
    name: "account-profile"
  }, {
    path: "/account/vouchers",
    component: _621c18de,
    name: "account-vouchers"
  }, {
    path: "/account/wishlist",
    component: _6a297c5e,
    name: "account-wishlist"
  }, {
    path: "/affiliate/create-affiliate",
    component: _7d07972b,
    name: "affiliate-create-affiliate"
  }, {
    path: "/affiliate/home",
    component: _52169c8e,
    name: "affiliate-home"
  }, {
    path: "/affiliate/partner",
    component: _f8a2a3e2,
    name: "affiliate-partner"
  }, {
    path: "/products/all",
    component: _24904260,
    name: "products-all"
  }, {
    path: "/account/address/add",
    component: _098141ac,
    name: "account-address-add"
  }, {
    path: "/account/affiliate/bank-account",
    component: _a6cd76a6,
    name: "account-affiliate-bank-account"
  }, {
    path: "/account/affiliate/commission",
    component: _4546f8bc,
    name: "account-affiliate-commission"
  }, {
    path: "/account/affiliate/product-list",
    component: _698827cd,
    name: "account-affiliate-product-list"
  }, {
    path: "/account/payment/add",
    component: _5ac47988,
    name: "account-payment-add"
  }, {
    path: "/account/profile/edit",
    component: _691604bf,
    name: "account-profile-edit"
  }, {
    path: "/account/shop/my-order",
    component: _5179ae0d,
    name: "account-shop-my-order"
  }, {
    path: "/account/shop/order-review",
    component: _47d40452,
    name: "account-shop-order-review"
  }, {
    path: "/account/shop/warranty-history",
    component: _37c65a63,
    name: "account-shop-warranty-history"
  }, {
    path: "/account/shop/wishlist",
    component: _204e3de5,
    name: "account-shop-wishlist"
  }, {
    path: "/account/affiliate/bank-account/add",
    component: _8b426c88,
    name: "account-affiliate-bank-account-add"
  }, {
    path: "/account/affiliate/commission/withdrawal",
    component: _62fa27fe,
    name: "account-affiliate-commission-withdrawal"
  }, {
    path: "/account/affiliate/product-list/add-product",
    component: _561d5ffe,
    name: "account-affiliate-product-list-add-product"
  }, {
    path: "/account/shop/my-order/offline",
    component: _1fdd6de1,
    name: "account-shop-my-order-offline"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/account/shop/my-order/offline/detail/:order_id",
    component: _3c13d911,
    name: "account-shop-my-order-offline-detail-order_id"
  }, {
    path: "/account/shop/my-order/review/add/:id?",
    component: _6243b12c,
    name: "account-shop-my-order-review-add-id"
  }, {
    path: "/account/shop/my-order/offline/detail/:order_id/invoice",
    component: _4201402c,
    name: "account-shop-my-order-offline-detail-order_id-invoice"
  }, {
    path: "/account/shop/my-order/detail/:order_id",
    component: _37927665,
    name: "account-shop-my-order-detail-order_id"
  }, {
    path: "/account/shop/my-order/detail/:order_id/invoice",
    component: _584dd880,
    name: "account-shop-my-order-detail-order_id-invoice"
  }, {
    path: "/account/shop/my-order/detail/:order_id/invoice-backup",
    component: _20286f42,
    name: "account-shop-my-order-detail-order_id-invoice-backup"
  }, {
    path: "/account/address/edit/:id?",
    component: _8f6b2b08,
    name: "account-address-edit-id"
  }, {
    path: "/affiliate/products/:section",
    component: _754bf0f8,
    name: "affiliate-products-section"
  }, {
    path: "/password/reset/:token?",
    component: _252ce834,
    name: "password-reset-token"
  }, {
    path: "/review/add/:id?",
    component: _4a143902,
    name: "review-add-id"
  }, {
    path: "/c1/:slug?",
    component: _32be645a,
    name: "c1-slug"
  }, {
    path: "/c2/:slug?",
    component: _7b858094,
    name: "c2-slug"
  }, {
    path: "/c3/:slug?",
    component: _106a3355,
    name: "c3-slug"
  }, {
    path: "/linktree/:id?",
    component: _20d251a6,
    name: "linktree-id"
  }, {
    path: "/page/:section",
    component: _12fa402f,
    name: "page-section"
  }, {
    path: "/partner/:id",
    component: _66da5279,
    name: "partner-id"
  }, {
    path: "/payment-confirmation/:order_id?",
    component: _4e33547c,
    name: "payment-confirmation-order_id"
  }, {
    path: "/payment-detail/:order_id?",
    component: _122e2f9e,
    name: "payment-detail-order_id"
  }, {
    path: "/product/:slug",
    component: _27eb6c73,
    name: "product-slug"
  }, {
    path: "/products/:section",
    component: _2a40083a,
    name: "products-section"
  }, {
    path: "/sale/:id",
    component: _f2246742,
    name: "sale-id"
  }, {
    path: "/users/:slug",
    component: _465cdf0c,
    name: "users-slug"
  }, {
    path: "/sale/:id/brand/:brandId?",
    component: _7787220e,
    name: "sale-id-brand-brandId"
  }, {
    path: "/sale/:id/section/:idSection?",
    component: _661ec510,
    name: "sale-id-section-idSection"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
